import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function ContractAuto() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ul className="list_dot"><li><h4 className="title">계약서와 확인·설명서에 필요한 데이터를 알아서 척척 입력​</h4><Image className="img_guide" src="/image/desktop/popup/contract02_01.png" alt={"\uACC4\uC57D\uC11C\uB97C \uC791\uC131\uD558\uC2E4 \uC8FC\uC18C\uB97C \uC785\uB825\uD558\uAE30"} width={100} height={100} /></li><li><h4 className="title">열람한 공부를 직접 보면서 계약서 작성도 가능해요!</h4><Image className="img_guide" src="/image/desktop/popup/contract02_02.png" alt={"\uC5F4\uB78C\uC744 \uC6D0\uD558\uB294 \uACF5\uBD80\uB9CC \uC120\uD0DD\uD558\uAE30"} width={100} height={100} /></li><li><h4 className="title">계약서 출력 전! 공부데이터와 비교하고 끝까지 안전하게</h4><Image className="img_guide" src="/image/desktop/popup/contract02_03.png" alt={"\uC120\uD0DD\uD55C \uACF5\uBD80\uB97C \uC774\uC2E4\uC7A5\uC774 \uC54C\uC544\uC11C \uC5F4\uB78C"} width={100} height={100} /></li></ul>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}